import React, { FC, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import { Button, ButtonIntent, ButtonType } from 'app/design-system/components/Button';
import { Icon, IconSize } from 'app/design-system/components/Icon';
import { StepperContext } from 'app/design-system/components/Stepper/context';
import { useTranslation } from 'app/lang';
import { closeSigningDialog } from 'app/modules/SigningNew/actions';
import { allowFreshChat } from 'app/ssr/config';

import { FORWARD_BUTTON_CONTENT } from '../../constants';
import { RegContext } from '../../context';
import { getBackwardButtonText } from '../../utils/signing-helpers';
import { SigningHelpButton } from '../SigningHelpButton';

import styles from './SignModal.module.scss';

export const SignFooter: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { regData, setRegData } = useContext(RegContext);
  const { activeStep, backwardStep } = useContext(StepperContext);

  const { disabled, checked } = regData;

  const backwardButtonHandler = useCallback(() => {
    if (activeStep === 2) {
      activeStep === 2 && setRegData((prevState) => ({ ...prevState, codeError: null }));
      backwardStep();
    }
    else {
      dispatch(closeSigningDialog());
    }
  }, [activeStep]);

  const backwardButtonText = t(getBackwardButtonText(regData));
  const backwardButton = (
    <Button type={ButtonType.BUTTON}
            intent={ButtonIntent.DEFAULT}
            onClick={backwardButtonHandler}
            disabled={disabled}
            className={styles.footerCancelButton}
            data-test="registration-cancel">
      {backwardButtonText}
    </Button>
  );

  const buttonTextClassNames = classNames(styles.footerEnterButton, {
    [styles.iconButton]: activeStep === 3,
  });

  const forwardButtonText = checked
    ? (
      <Icon icon="check"
            size={IconSize.MEDIUM}
            className={styles.iconSuccess} />
    )
    : (
      t(FORWARD_BUTTON_CONTENT[`STEP${activeStep}`])
    );

  return (
    <>
      {allowFreshChat && <SigningHelpButton />}
      {backwardButton}
      <Button type={ButtonType.SUBMIT}
              intent={!checked ? ButtonIntent.CALL_TO_ACTION : ButtonIntent.SUCCESS}
              form={`registrationFormStep_${activeStep}`}
              loading={disabled && !checked}
              className={buttonTextClassNames}
              data-test="registration-submit">
        {forwardButtonText}
      </Button>
    </>
  );
};
